// store.js
import { createStore } from 'redux';

// Define initial state
const initialState = {
website_url: '', // Initial state for the website URL
menu_url:'',
review_url:'',
social_url:'',
shop_url:'',
properties_url:'',
appointment_url:'',
email:'',
phone_nr: ''
};

// Define reducer
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_WEBSITE_URL':
            return {
                ...state,
                webswebsite_urliteUrl: action.payload,
                webmenu_urliteUrl:action.payload,
                webreview_urliteUrl:action.payload,
                websocial_urliteUrl:action.payload,
                webshop_urliteUrl:action.payload,
                webproperties_urliteUrl:action.payload,
                webappointment_urlUrl:action.payload
            };
        case 'SET_EMAIL':
            return {
                ...state,
                email: action.payload
            };
        case 'SET_PHONE_NR':
            return {
                ...state,
                phone_nr: action.payload
            };
        default:
            return state;
    }
};

// Create the Redux store
const store = createStore(reducer);

export default store;
